var map = {
	"./black/yichu2.png": "6xer",
	"./blue/yichu2.png": "yIys",
	"./white/yichu2.png": "Bfuk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GLPi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/yichu2\.png$
// module id = GLPi
// module chunks = 24